import React from 'react';
export function VolumesDetail() {
  const primariaVols = [{
    vol: '📘 Tomo 1 — 1° Grado',
    content: 'Números que tienen sentido'
  }, {
    vol: '📗 Tomo 2 — 2° Grado',
    content: 'Operaciones con propósito'
  }, {
    vol: '📙 Tomo 3 — 3° Grado',
    content: 'Pensar antes de calcular'
  }, {
    vol: '📕 Tomo 4 — 4° Grado',
    content: 'Estrategias que funcionan'
  }, {
    vol: '📓 Tomo 5 — 5° Grado',
    content: 'Matemática para resolver'
  }, {
    vol: '📔 Tomo 6 — 6° Grado',
    content: 'Conectar y profundizar'
  }];
  const secundariaVols = [{
    vol: '📘 Tomo 1 — 1° Año',
    content: 'Álgebra con sentido'
  }, {
    vol: '📗 Tomo 2 — 2° Año',
    content: 'Funciones y variación'
  }, {
    vol: '📙 Tomo 3 — 3° Año',
    content: 'Geometría y argumentación'
  }, {
    vol: '📕 Tomo 4 — 4° Año',
    content: 'Modelización y problemas reales'
  }, {
    vol: '📓 Tomo 5 — 5° Año',
    content: 'Estadística y probabilidad'
  }, {
    vol: '📔 Tomo 6 — 6° Año',
    content: 'Integración y pensamiento matemático'
  }];
  const includes = ['Planificación anual lista para la carpeta docente', 'Secuencia didáctica completa (inicio–desarrollo–cierre)', 'Actividades y consignas listas para usar', 'Rúbricas y evidencias de evaluación incluidas', 'Problemas contextualizados por grado y año', 'Alineado al diseño curricular argentino 2026'];
  return <section className="bg-brand-dark py-24 px-4 border-t border-brand-border" data-id="element-269">
      <div className="max-w-5xl mx-auto" data-id="element-270">
        <h2 className="text-4xl md:text-5xl font-heading font-bold text-center text-white mb-16" data-id="element-271">
          Lo que <span className="text-brand-accent" data-id="element-272">recibís</span>
        </h2>
        <div className="max-w-2xl mx-auto flex flex-col gap-8 mb-20" data-id="element-273">
          <div className="bg-brand-card border border-brand-accent/40 rounded-2xl p-6 md:p-8" data-id="element-274">
            <div className="mb-6" data-id="element-275">
              <h3 className="text-xl md:text-2xl font-heading font-bold uppercase mb-1 text-brand-accent" data-id="element-276">
                📘 PRIMARIA — 6 Tomos
              </h3>
              <p className="text-white/70 text-sm" data-id="element-277">
                Para docentes de Matemática de 1° a 6° grado
              </p>
            </div>
            <div className="space-y-5" data-id="element-278">
              {primariaVols.map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-279">
                  <p className="text-white/90 text-base leading-relaxed" data-id="element-280">
                    <span className="font-bold text-white mr-1" data-id="element-281">
                      {item.vol}:
                    </span>
                    {item.content}
                  </p>
                </div>)}
            </div>
          </div>
          <div className="bg-brand-card border border-brand-accent/40 rounded-2xl p-6 md:p-8" data-id="element-282">
            <div className="mb-6" data-id="element-283">
              <h3 className="text-xl md:text-2xl font-heading font-bold uppercase mb-1 text-brand-accent" data-id="element-284">
                📗 SECUNDARIA — 6 Tomos
              </h3>
              <p className="text-white/70 text-sm" data-id="element-285">
                Para docentes de Matemática de 1° a 6° año
              </p>
            </div>
            <div className="space-y-5" data-id="element-286">
              {secundariaVols.map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-287">
                  <p className="text-white/90 text-base leading-relaxed" data-id="element-288">
                    <span className="font-bold text-white mr-1" data-id="element-289">
                      {item.vol}:
                    </span>
                    {item.content}
                  </p>
                </div>)}
            </div>
          </div>
        </div>
        <div className="max-w-2xl mx-auto bg-brand-card rounded-2xl p-8 md:p-12 border-2 border-brand-accent/40" data-id="element-290">
          <h3 className="text-2xl md:text-3xl font-heading font-bold mb-8 md:mb-10 text-center text-brand-accent" data-id="element-291">
            Cada tomo incluye:
          </h3>
          <div className="flex flex-col gap-5 md:gap-6" data-id="element-292">
            {includes.map((item, i) => <div key={i} className="flex items-start gap-4" data-id="element-293">
                <div className="flex-shrink-0 w-8 h-8 bg-[#0099CC] rounded-md flex items-center justify-center mt-0.5 text-white font-black" data-id="element-294">
                  ✓
                </div>
                <span className="font-bold text-white text-lg md:text-xl leading-snug" data-id="element-295">
                  {item}
                </span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}